/**
 * SophieSubCampPackService - Fetch subscribed STB campaign pack info via SOAP
 */

import axios from 'axios';
import { NOWID_PROXY_URL } from '../config';

const SophieSubCampPackService = {
  /**
   * getSophieSubCampPackInfo
   * @param {string} fsa - Subscription Account ID
   * @returns {Promise<object|null>} Subscribed campaign pack info
   */
  fetchSubCampPack: async (fsa) => {
    if (!fsa) {
      throw new Error('FSA is required for getSophieSubCampPackInfo');
    }

    const response = await axios.post(NOWID_PROXY_URL, {
      proxyTarget: 'sophie',
      endpoint: 'SBIMSExt/getSophieSubCampPackInfo',
      method: 'SOAP',
      payload: {
        fsa,
        soapAction: 'getSophieSubCampPackInfo',
      },
    }, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response.data?.subCampPack || null;
  },
};

export default SophieSubCampPackService;
